import React, { createContext, useContext, useState, useCallback } from 'react';

const AnnouncerContext = createContext();

/**
 * Provider for screen reader announcements
 */
export const AnnouncerProvider = ({ children }) => {
  const [announcement, setAnnouncement] = useState({ message: '', priority: 'polite' });

  const announce = useCallback((message, priority = 'polite') => {
    // Reset first to ensure screen readers pick up repeated messages
    setAnnouncement({ message: '', priority });
    setTimeout(() => {
      setAnnouncement({ message, priority });
    }, 50);
  }, []);

  const announcePolite = useCallback((message) => announce(message, 'polite'), [announce]);
  const announceAssertive = useCallback((message) => announce(message, 'assertive'), [announce]);

  return (
    <AnnouncerContext.Provider value={{ announce, announcePolite, announceAssertive }}>
      {children}
      {/* Live regions */}
      <div
        role="status"
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
      >
        {announcement.priority === 'polite' && announcement.message}
      </div>
      <div
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        className="sr-only"
      >
        {announcement.priority === 'assertive' && announcement.message}
      </div>
    </AnnouncerContext.Provider>
  );
};

export const useAnnouncer = () => {
  const context = useContext(AnnouncerContext);
  if (!context) {
    throw new Error('useAnnouncer must be used within AnnouncerProvider');
  }
  return context;
};

export default AnnouncerContext;
